import { APP_ENV } from 'config'
import { store } from 'store'
import { consentSelectors, ConsentStatus } from 'store/consent'
import { settingsSelectors } from 'store/settings'
import { captureFirebase } from './firebase'
import { capturePosthog, syncPosthogConsent } from './posthog'

type QueuedEvent = { event: string; properties?: Record<string, unknown> }

const QUEUE_LIMIT = 50
let queue: QueuedEvent[] = []
let lastStatus: ConsentStatus | undefined

const commonProperties = () => {
  const state = store.getState()
  return {
    environment: APP_ENV,
    tenant_id: settingsSelectors.tenantId(state),
    tenant_name: settingsSelectors.tenantName(state),
  }
}

const dispatchFirebase = ({ event, properties }: QueuedEvent) => {
  captureFirebase(event, { ...commonProperties(), ...properties })
}

export const analytics = {
  track(event: string, properties?: Record<string, unknown>): void {
    capturePosthog(event, { ...commonProperties(), ...properties })
    // gtag / GTM / Klaviyo: add here

    const status = consentSelectors.status(store.getState())
    if (status === 'denied') return
    if (status === 'pending') {
      queue.push({ event, properties })
      if (queue.length > QUEUE_LIMIT) queue.shift()
      return
    }
    dispatchFirebase({ event, properties })
  },
}

store.subscribe(() => {
  const status = consentSelectors.status(store.getState())
  if (status === lastStatus) return
  lastStatus = status

  syncPosthogConsent(status)

  if (status === 'pending' || !queue.length) return
  const queued = queue
  queue = []
  if (status === 'granted') queued.forEach(dispatchFirebase)
})
